import { GetUtilCategoryModel } from "@factory/model/query-model-util-category";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";

import { utilCategoryFormDefault } from "./form.default";
import { UtilCategoryFormSchema } from "./form.rule";

export const useFormDefaultUtilCategory = () => {
  const { formatDate } = useDateTimeContext();

  const getDefault = (cachedValue: GetUtilCategoryModel | undefined) => {
    return !cachedValue
      ? utilCategoryFormDefault
      : ({
          tenant: cachedValue.tenant,
          name: cachedValue.name,
          description: cachedValue.description,
        } as UtilCategoryFormSchema);
  };

  return {
    getDefault,
  };
};
